import { computed, DestroyRef, Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserSessionService } from '../../services/user-session.service';
import { FeatureFlag } from '../../enums/feature-flags.enums';
import { IfHasChildPermissionDirective } from '../if-has-child-permission/if-has-child-permission.directive';

@Directive({
	selector: '[ifFeatureEnabled]',
	standalone: true
})
export class IfFeatureEnabledDirective {
	private readonly templateRef = inject(TemplateRef<unknown>);
	private readonly viewContainer = inject(ViewContainerRef);
	private readonly userSessionService = inject(UserSessionService);
	private readonly parent = inject(IfHasChildPermissionDirective, { optional: true, skipSelf: true });

	public readonly ifFeatureEnabled = input.required<FeatureFlag>();

	private hasView = false;

	private readonly shouldRender = computed(() => this.userSessionService.isFeatureEnabled(this.ifFeatureEnabled()));

	constructor() {
		const destroyRef = inject(DestroyRef);

		effect(() => {
			const shouldRender = this.shouldRender();

			if (shouldRender && !this.hasView) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				this.hasView = true;
			} else if (!shouldRender && this.hasView) {
				this.viewContainer.clear();
				this.hasView = false;
			}
		});

		if (this.parent) {
			const parent = this.parent;
			// Same computed the render decision uses, so "is this rendered?" and "does the parent stay
			// visible?" can't drift apart.
			parent.register(this.shouldRender);
			destroyRef.onDestroy(() => parent.unregister(this.shouldRender));
		}
	}

}
